
import { HttpGetSurChargeRuleList, HttpDeleteSurChargeRuleOne } from '@/service/account';
import TableList from "@components/templates/tablelist";
import { mapGetters } from 'vuex';
import compIndex from "./update";
export default {
    mixins: [TableList],
    components: {
        compIndex,
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            workOrderSearchList: []
        };
    },
    methods: {
        ajaxRequest: HttpGetSurChargeRuleList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'surchargeruleUpdate',
                        params: { type: "add"},
                    });
                    break;
                case "edit":
                    this.$router.push({
                        name: 'surchargeruleUpdate',
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    break;
                case "query":
                    this.operate = {
                        title: this.$t('global.common.query',{defaultValue:'查看'}),
                        show: true,
                        width: 1200,
                        component: "compIndex",
                        activeid: params,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case "delete":
                    this.operate = {
                        show: true,
                        alert: 'warning',
                        params: { id: params },
                        title: this.$t('global.common.delete',{defaultValue:'删除'}),
                        ajaxRequest: HttpDeleteSurChargeRuleOne,
                        showDesc: false,
                        formdata: [
                            {
                                label: this.$t('global.common.notes',{defaultValue:'备注'}),
                                tag: "vTextarea",
                                key: 'remark',
                                span: 24,
                                labelWidth: 60,
                                required: false,
                            }
                        ]
                    }
                    break;
                case "queryBlank":
                    var url = this.$router.resolve({
                        name: "surchargeruleUpdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;

            }
        },
        getOperateNodeMap(row) {
            const { id } = row;
            return [
                {
                    label: this.$t('global.common.query'),
                    to: {
                        name: "surchargeruleUpdate",
                        params: {
                            type: 'query',
                        },
                        query: { id }
                    },
                    show: true
                },
                {
                    label: this.$t('global.common.edit'),
                    params: id,
                    to: {
                        name: "surchargeruleUpdate",
                        params: {
                            type: 'edit',
                        },
                        query: { id }
                    },
                    show: true
                },
                {
                    label: this.$t('global.common.delete',{defaultValue:'删除'}),
                    params: id,
                    operate: 'delete',
                    show: true
                },
            ];
        },
    },
    computed: {
        ToolsData() {
            return [
                {
                    label: this.$t('global.common.operate_add',{defaultValue:'添加'}),
                    operate: "add",
                    theme:"primary",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('fbb.carrier.extra_rule_name',{defaultValue:'规则名称'}),
                    key: 'CN_ruleName',
                    tag: 'vInput',
                    options:[],
                    show: true,
                },
                {
                    label: this.$t('global.common.createdtime',{defaultValue:'创建时间'}),
                    tag: 'vDatepicker',
                    style: "width:250px",
                    key: 'BT_createdAt',
                    props: {
                        format: 'yy-mm-dd ~ yy-mm-dd',
                        confirm: false,
                    },
                    show: true,
                }
            ]
        },
        columns() {
            return [
                {
                    title: this.$t('global.common.actions',{defaultValue:'操作'}),
                    width: 100,
                    render: this.getOperateNodes
                },
                {
                    title: this.$t('fbb.carrier.extra_rule_name',{defaultValue:'规则名称'}),
                    key: 'ruleName',
                    render: (h, { row }) => {
                        return <div>
                            <div>
                                <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.ruleName}</a>
                                <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                            </div>
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.addonRule.ruleRangeFormula',{defaultValue:'规则公式'}),
                    key: 'ruleRangeFormula',

                },
                {
                    title: this.$t('fbb.adjustment.created_name',{defaultValue:'创建人'}),
                    key: 'createdName',
                },
                {
                    title: this.$t('global.common.createdtime',{defaultValue:'创建时间'}),
                    key: 'createdAt',
                }];
        },
    },
};




